// Empty state (DESIGN.md 10.7): centered monogram + message + CTA.

import { BrandMark } from './BrandMark';

interface Props {
  title: string;
  guidance: string;
  ctaLabel?: string;
  onCta?: () => void;
}

export function EmptyState({ title, guidance, ctaLabel, onCta }: Props) {
  return (
    <div
      className="section"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '0.75rem' }}
    >
      <BrandMark size={32} className="text-accent" />
      <h2 style={{ fontSize: '1.125rem', fontWeight: 600 }}>{title}</h2>
      <p className="muted prose-measure">{guidance}</p>
      {ctaLabel && onCta && (
        <button type="button" className="btn btn-primary" onClick={onCta}>
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
